import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { CustomCardHeader } from '../../common/custom-card-header/CustomCardHeader';
import { AccountsEdit } from './accountsEdit/accountsEdit';
import { AccountsReadOnly } from './accountsReadOnly/accountsReadOnly';

const ABOUT_ME_UPDATING_PARTS = {
  about_me_pref: 'about_me_pref',
  about_me_edit: 'about_me_edit',
};

export const Accounts = ({
  updatingParts,
  handleDataChange,
  profileData,
  isSM,
}) => {
  const [isEditingMode, setIsEditingMode] = useState(false);

  // accounts

  const handleEditSubmit = (newValues) => {
    handleDataChange(ABOUT_ME_UPDATING_PARTS.about_me_edit, newValues, () => {
      setIsEditingMode(false);
    });
  };

  return (
    <Card
      className='no-shadow profile-about-me-wrapper'
      style={{
        border: `1px solid #2E2B2B`,
        backgroundColor: 'transparent',
        marginRight: isSM ? 12 : 0,
        marginLeft: isSM ? 12 : 0,
      }}
    >
      <CustomCardHeader
        title='accounts'
        actionBtnLabel={isEditingMode ? 'Close' : 'Edit'}
        handleActionBtnClick={(e) => {
          setIsEditingMode(!isEditingMode);
        }}
      />
      <CardBody>
        {isEditingMode ? (
          <AccountsEdit
            userData={profileData}
            isUpdating={updatingParts[ABOUT_ME_UPDATING_PARTS.about_me_edit]}
            onSubmit={handleEditSubmit}
          />
        ) : (
          <AccountsReadOnly preferences={profileData} />
        )}
      </CardBody>
    </Card>
  );
};
